import { createApp } from 'vue';

import App from '@/App.vue';
import { registerPlugins } from '@core/utils/plugins';

import * as Sentry from "@sentry/vue";

// Styles
import '@core/scss/template/index.scss';
import '@styles/styles.scss';

// Create vue app
const app = createApp(App)

Sentry.init({
  app,
  dsn: "https://0c74bfe7ac4616ee8d0a15aee2c67d13@o4509231955050496.ingest.de.sentry.io/4509232294133840",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

// Register plugins
registerPlugins(app)

// Mount vue app
app.mount('#app')
